<template>
  <h2 class="emd-text _size_default _type_caption">
    {{ $t('charge.detail.payment-method.title') }}
  </h2>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodTitle'
}
</script>
